const ITEMS = [
  "Arquitectura de autor",
  "Viviendas exclusivas",
  "Asesoramiento personal",
  "Ubicaciones privilegiadas",
  "Tu hogar, nuestro compromiso",
];

const Marquee = () => (
  <div className="marquee-wrap overflow-hidden border-y border-gold/15 bg-ink2/60 py-6">
    <div className="animate-marquee flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} aria-hidden={copy === 1} className="flex items-center">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center whitespace-nowrap">
              <span className="px-8 font-serif text-2xl uppercase tracking-[0.2em] text-gold/85 md:text-3xl">{item}</span>
              <span className="h-1.5 w-1.5 rotate-45 bg-gold/60" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
